// storeData.js
// THIS IS YOUR DATA FILE - ONLY EDIT THIS FILE TO ADD/REMOVE VIDEOS

export const STORE_DATA = {
  storeInfo: {
    name: "Nether Store",
    tagline: "Bringing Your Ideas to Life",
    subtitle: "Professional Minecraft Mods & Modpacks",
    madeBy: "Roasty69"
  },

  clients: [
    {
      name: "Mc flame",
      image: "https://yt3.googleusercontent.com/YRiuDwpUPZ_JY7p_rucfwgXqvzaJ3AyU0MvTI0Qmcr5hbPUoK1BHatq4T00Jo2NWLxTQw5TpAA=s160-c-k-c0x00ffffff-no-rj",
      subs: "2.57m",
      channel: "https://www.youtube.com/@Mc_flame/featured"
    },
    {
      name: "Pat",
      image: "https://yt3.googleusercontent.com/ytc/AIdro_lvCsWOJb7XyfAFYiviN5X4ekWHy1htbYd8H3ksXkxtNyE=s160-c-k-c0x00ffffff-no-rj",
      subs: "1.14m",
      channel: "https://www.youtube.com/@Pat1/featured"
    },
    {
      name: "Dennus2",
      image: "https://yt3.googleusercontent.com/4sr-3SaTAov3PlvtdRY9ACimFOVh5NVuqyVJSK2bVucAFWmaSdqCVvGCwJ9amt70rqfBPuRPr7E=s160-c-k-c0x00ffffff-no-rj",
      subs: "583k",
      channel: "https://www.youtube.com/@Dennus2"
    },
    {
      name: "Chestos",
      image: "https://yt3.googleusercontent.com/5sRcV-X3qQ5pEp2UOngqLeHwsb_S5CB5ErALZZkooClmP8jgnXBqs9DLEKO8K7xARMWOjm7OIMw=s160-c-k-c0x00ffffff-no-rj",
      subs: "314k",
      channel: "https://www.youtube.com/@Chestos1/featured"
    },
    {
      name: "Flame playz",
      image: "https://yt3.googleusercontent.com/SWQT-szlo8UzHuJleZJibupQar3EWGvozIR6N3-AkWyTao5P7UptB96As3X35ndyRfWkkDEHHjo=s160-c-k-c0x00ffffff-no-rj",
      subs: "1.36m",
      channel: "https://www.youtube.com/@Flame_playz"
    },
    {
      name: "AdiSpot",
      image: "https://yt3.googleusercontent.com/2teB4BB1-Li8EhcB0pOfXDrkhauPKDQMXgDBScVciSKE49Yb3i6OayBWW4KhsBkqlqxW9384=s160-c-k-c0x00ffffff-no-rj",
      subs: "1.98m",
      channel: "https://www.youtube.com/@AdiSpot/videos"
    },
    {
      name: "Azpaz Tv",
      image: "https://yt3.googleusercontent.com/ytc/AIdro_kFKOnIYJzAlVo30XtlILESlaH_X24-Uwte2JO2j-rZMFY=s160-c-k-c0x00ffffff-no-rj",
      subs: "731k",
      channel: "https://www.youtube.com/@AzpazTv"
    }   
  ],

  // ADD NEW VIDEOS HERE AT THE TOP - THEY WILL APPEAR FIRST ON YOUR WEBSITE
  videos: [
    {
      title: "Can You Keep DRAGON as a Pet?",
      videoUrl: "https://www.youtube.com/watch?v=0acMGORyiA8",
      price: "80$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "What's Inside Bloodbath in Minecraft?",
      videoUrl: "https://www.youtube.com/watch?v=mxU1k7lePKg",
      price: "80$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Testing Scary Myths Caught in Minecraft Footage…",
      videoUrl: "https://www.youtube.com/watch?v=ETKzMMt9wGE",
      price: "60$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But You Can Combine Any Mobs!",
      videoUrl: "https://www.youtube.com/watch?v=NmxoC89w1-A",
      price: "65$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "How Confusing Can The Illusion Get?",
      videoUrl: "https://www.youtube.com/watch?v=ahXUeAOONaM",
      price: "60$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Searching For a World That Doesn't Exist...",
      videoUrl: "https://www.youtube.com/watch?v=yBwL_An2mDw&t=111s",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But You Can Fuse SCARY MYTHS!",
      videoUrl: "https://www.youtube.com/watch?v=-STC9HHSpos",
      price: "65$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Exploring a Forgotten World In Minecraft…",
      videoUrl: "https://www.youtube.com/watch?v=6NTVYDdE5a0",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Can You Keep a SCORPION as a Pet?",
      videoUrl: "https://www.youtube.com/watch?v=4EYUv8u7ir0",
      price: "65$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft But You Can Mine 1 TRILLION Blocks!",
      videoUrl: "https://www.youtube.com/watch?v=Y-YWYIsOs18",
      price: "65$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Solving a Missing Player's Minecraft World…",
      videoUrl: "https://www.youtube.com/watch?v=A3NhmTQ1zgU",
      price: "40$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "How Long Can Minion.Exe Get?",
      videoUrl: "https://www.youtube.com/watch?v=Zt7pUZsoXBs",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Testing Scary Minecraft Myths That Are Phobias...",
      videoUrl: "https://www.youtube.com/watch?v=Va8AXL8edNI",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Testing Scary Minecraft Myths That Are Unsolved…",
      videoUrl: "https://www.youtube.com/watch?v=gEVCXrjvaT4",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
               {
      title: "Minecraft Mobs If They Had Jobs",
      videoUrl: "https://www.youtube.com/watch?v=n31qOWV3ev0",
      price: "65$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },

             {
      title: "The DARK Truth about Sulfur Cubes in Minecraft...",
      videoUrl: "https://www.youtube.com/watch?v=jStvvGANn10",
      price: "65$",
      version: "Minecraft 26.2",
      badge: "Mod"
    },


             {
      title: "Why I Flooded My Entire World in Minecraft!?",
      videoUrl: "https://www.youtube.com/watch?v=Piu0FBw3Hwo",
      price: "65$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
                {
      title: "I trapped EVERY SCARY MYTH in Minecraft",
      videoUrl: "https://www.youtube.com/watch?v=pB5te69aYQw",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
             {
      title: "Trolling my friend's as a vampire",
      videoUrl: "https://www.youtube.com/watch?v=0Xyp82NfHWs",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
         {
      title: "MONEY vs DIAMOND SKYBLOCK WAR",
      videoUrl: "https://www.youtube.com/watch?v=iGkLirqY-Cg",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
      {
      title: "I Flooded My Entire World with Chocolate in Minecraft!",
      videoUrl: "https://www.youtube.com/watch?v=ZKJvVZks9fg",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But You Can Open ANY MOBS!",
      videoUrl: "https://www.youtube.com/watch?v=0iTNen9sIec",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Hacker vs Noob vs Pro Luckyblock Race",
      videoUrl: "https://www.youtube.com/watch?v=p8eWwwgsfVM",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, but Every Diamond = MORE SCARY...",
      videoUrl: "https://www.youtube.com/watch?v=urOIfYAj-oI",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But Mobs Are Lucky...",
      videoUrl: "https://www.youtube.com/watch?v=aE7CdrWV1vo&t=2s",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But Drops Are Very Random...",
      videoUrl: "https://www.youtube.com/watch?v=ufBEyvDx2ac&t=",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft Mobs if they Had Dreams",
      videoUrl: "https://www.youtube.com/watch?v=R3y-42oZ8bI",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Guns vs Minecraft's Strongest Bosses",
      videoUrl: "https://www.youtube.com/watch?v=X2mHqZO7Pb4",
      price: "30$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "How Scary Myths Act when you log off…",
      videoUrl: "https://www.youtube.com/watch?v=aKjfCpvJc-w",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft But Any Scary Build Hack I Get",
      videoUrl: "https://www.youtube.com/watch?v=i1PjjYkDumU",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "I tested your TERRIBLE secret base ideas",
      videoUrl: "https://youtu.be/U5WjqJe8rBk?si=2pByYV7-HbBR3M22",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "NOOB vs PRO: CRUISE SHIP BATTLE In Minecraft",
      videoUrl: "https://www.youtube.com/watch?v=45GEmPcemW0",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "We Created bunker to survive PORTAL TSUNAMI In Minecraft",
      videoUrl: "https://www.youtube.com/watch?v=dcdq11F_3_E",
      price: "30$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "I Crafted Minecraft's Most OP Block",
      videoUrl: "https://www.youtube.com/watch?v=9cUs4Zg5YwU",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "EVERY MINUTE COCA-COLA RISES HIGHER IN MINECRAFT!",
      videoUrl: "https://www.youtube.com/watch?v=YyVTljIEx5E",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Adopted By A HACKER FAMILY In Minecraft!",
      videoUrl: "https://www.youtube.com/watch?v=fVV5mjHSQuQ",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "I Survived 100 Days as THE BLOOP in Minecraft",
      videoUrl: "https://www.youtube.com/watch?v=VaLKsy9wAIA",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "POOR BABY Was ADOPTED by a RICH FAMILY!",
      videoUrl: "https://www.youtube.com/watch?v=RLX2EEPcxoU",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "I Pranked My Friend with FAKE Blocks in Minecraft",
      videoUrl: "https://www.youtube.com/watch?v=tGKXRP2q1_Y",
      price: "30$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "I Cheated In a Santa Mob Battle In MINECRAFT",
      videoUrl: "https://www.youtube.com/watch?v=7zF119VOqns",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "I Stole My Friend's Immortality in Minecraft",
      videoUrl: "https://www.youtube.com/watch?v=2C6vXefO-pc",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "I Built Most Illegal Traps In Minecraft !",
      videoUrl: "https://www.youtube.com/watch?v=aVYD6vC_oz0&t=78s",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft but You Mine 1 BILLION Blocks",
      videoUrl: "https://www.youtube.com/watch?v=w2JB-fx0Zxk",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Surviving 99 Nights in Cursed Forest in Minecraft!",
      videoUrl: "https://www.youtube.com/watch?v=vAnXn7mDoq0",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft But Christmas Doesn't Happen Anymore...",
      videoUrl: "https://www.youtube.com/watch?v=85ph1ll8Xo8",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Plugin"
    },
    {
      title: "Minecraft, but EVERYTHING IS MADE OF BEDROCK",
      videoUrl: "https://www.youtube.com/watch?v=2QRutblf-F4",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Plugin"
    },
    {
      title: "Minecraft but 1,000,000 SUPER ITEMS...",
      videoUrl: "https://www.youtube.com/watch?v=uoD1M6Kg_yg",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Plugin"
    },
    {
      title: "I SPENT 100 DAYS IN THE ONE LUCKY BLOCk",
      videoUrl: "https://www.youtube.com/watch?v=mh1fWgasq3A",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Plugin"
    },
    {
      title: "I Open A Bussiness in Minecraft",
      videoUrl: "https://www.youtube.com/watch?v=pLoU9ttSZzM",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Plugin"
    },
    {
      title: "Everyone HATE me in Minecraft",
      videoUrl: "https://www.youtube.com/watch?v=8qt00oH8b4M",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Plugin"
    },
    {
      title: "Surviving 99 Nights in Cursed Forest in Minecraft!",
      videoUrl: "https://www.youtube.com/watch?v=vAnXn7mDoq0",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Milo CHOOSE The WRONG SLIDE in Minecraft",
      videoUrl: "https://youtu.be/E_6BMX7BG6U?si=9Y5NrtiqkvypIqPy",
      price: "30$",
      version: "Minecraft 1.20.1",
      badge: "Map"
    },
    {
      title: "NOOB vs PRO: SCARY PRANK HOUSE BUILD BATTLE In Minecraft",
      videoUrl: "https://www.youtube.com/watch?v=TWUtIzXgYoM",
      price: "30$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
     {
      title: "I Trolled my SISTER in a FAKE SIMULATION CHUNK in MINECRAFT",
      videoUrl: "https://www.youtube.com/watch?v=gM6xkSFOvqQ",
      price: "40$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "$1 vs $1,000,000 Illegal Base in Minecraft",
      videoUrl: "https://www.youtube.com/watch?v=4wtikGfSJYs",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "21 Illegal Houses In Minecraft!",
      videoUrl: "https://www.youtube.com/watch?v=bR9bAib7Ybo",
      price: "30$",
      version: "Minecraft 1.20.1",
      badge: "Map"
    },
    {
      title: "Minecraft But ITEMS ARE ALIVE!!",
      videoUrl: "https://www.youtube.com/watch?v=5Hvw5xqwMCw",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Evolving into The RICHEST of All In Minecraft!",
      videoUrl: "https://www.youtube.com/watch?v=Op-ACimzIRI&t=1s",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "How Minecraft Mobs Act if They Were Parents....",
      videoUrl: "https://www.youtube.com/watch?v=1Q_lBkgxsAo",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
     {
      title: "I Stole My Sister's ONE BLOCK in Minecraft",
      videoUrl: "https://www.youtube.com/watch?v=TWgBisuTlTM",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
     {
      title: "I Survived 100 Days as TRAIN EATER in Minecraft",
      videoUrl: "https://www.youtube.com/watch?v=45wzHeCFmS8",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
     {
      title: "Minecraft But Draw To Survive Challenge !!",
      videoUrl: "https://www.youtube.com/watch?v=QAgkbtiWfZI",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
     {
      title: "Minecraft, But From WAR to PEACE…",
      videoUrl: "https://www.youtube.com/watch?v=inRg3zpUpIA&t=2s",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
     {
      title: "minecraft but i can choose anything",
      videoUrl: "https://www.youtube.com/watch?v=Odlc5rzyt8A",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But I Can Buy Scary Entities Powers!",
      videoUrl: "https://www.youtube.com/watch?v=9AILyAt0EKU",
      price: "50$",
      version: "Minecraft 1.16.5",
      badge: "Mod"
    },
    {
      title: "Minecraft but i lost my memory",
      videoUrl: "https://www.youtube.com/watch?v=T777zqEw668",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Turning $1 RESTAURANT into $1,000,000 Restaurant in MINECRAFT..!",
      videoUrl: "https://www.youtube.com/watch?v=zpfvsWMLD9I&t=177s",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But I Open a School!",
      videoUrl: "https://www.youtube.com/watch?v=NTYOPUNexQk",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft but I Own A City",
      videoUrl: "https://www.youtube.com/watch?v=_9bOrFXFx14",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "IF YOU CHOOSE THE WRONG PORTAL, YOU DIE!",
      videoUrl: "https://www.youtube.com/watch?v=xtfwxsN95OM&t=1s",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But Mobs EAT You...",
      videoUrl: "https://www.youtube.com/watch?v=giDY2zSf-1s",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft But You Build It, You Get It!",
      videoUrl: "https://www.youtube.com/watch?v=LYEFFD1L95U",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But You Can Mine The Entire World...",
      videoUrl: "https://www.youtube.com/watch?v=1StU9y3qX6k",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But You Can Slice Anything...",
      videoUrl: "https://www.youtube.com/watch?v=2TjrnVhpbe8",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But Anything You Craft Works...",
      videoUrl: "https://www.youtube.com/watch?v=ouVIgyCzcfE",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "I Converted Every Mob Into Milk in Minecraft",
      videoUrl: "https://www.youtube.com/watch?v=U2MJ32fcga4",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But You Can Open Any MOBS!",
      videoUrl: "https://www.youtube.com/watch?v=Y9VpJ_AGL_o",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But I Can't Leave This Hole...",
      videoUrl: "https://www.youtube.com/watch?v=LowExcxb4iU",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Trapped on One Villager Block in Minecraft",
      videoUrl: "https://www.youtube.com/watch?v=pTjaVgKzSR0",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But My Deaths = World Size",
      videoUrl: "https://www.youtube.com/watch?v=u9UqNiEtBQQ",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But The World Is Small",
      videoUrl: "https://www.youtube.com/watch?v=UJfLRZTyNA8&t",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Map"
    },
    {
      title: "Minecraft, But You Are King of Villagers",
      videoUrl: "https://www.youtube.com/watch?v=q8LoI5WVGX4",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But You Can Craft Secret Bases",
      videoUrl: "https://www.youtube.com/watch?v=mT7ISq9nGsk",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But You Can Open Any Block!",
      videoUrl: "https://www.youtube.com/watch?v=DsiShEGZHC8",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft but you turn into a dragon",
      videoUrl: "https://www.youtube.com/watch?v=DFWsR4b73RU",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Converting Fake Minecraft shorts in REAL",
      videoUrl: "https://www.youtube.com/watch?v=3L9ih2GpUOA&t=59s",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Using POPPY PLAYTIME to Fool My Friends in Minecraft",
      videoUrl: "https://www.youtube.com/watch?v=GY5gY9GI81s",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Why I Ate My Friend's ENTIRE World",
      videoUrl: "https://www.youtube.com/watch?v=JUZlLD_Gdds",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "I Built an Illegal Villager Base in Minecraft",
      videoUrl: "https://www.youtube.com/watch?v=SCuljM5aIKM",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "I Fooled My Friend with IMMORTALITY",
      videoUrl: "https://www.youtube.com/watch?v=jPLkccUPk0s",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But You Are Immortal...",
      videoUrl: "https://www.youtube.com/watch?v=kSqnY--s48Y",
      price: "50$",
      version: "Minecraft 1.16.5",
      badge: "Mod"
    },
    {
      title: "I Found Minecraft’s Rarest Secret Mobs",
      videoUrl: "https://www.youtube.com/watch?v=CyexnJDn2K8",
      price: "30$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "I Opened a SCARY Shop in Minecraft !!!",
      videoUrl: "https://www.youtube.com/watch?v=kmfL1MYV798",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
     {
      title: "Minecraft, But Can You Raid My Scary Base?",
      videoUrl: "https://www.youtube.com/watch?v=T7srT-96Tdg",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
     {
      title: "Minecraft but Crafts Get Loooooonger....",
      videoUrl: "https://www.youtube.com/watch?v=28KjLNgWs0Q",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
     {
      title: "Minecraft, But Crafts Get Rounder?!",
      videoUrl: "https://www.youtube.com/watch?v=ZnDu1nuaEZk",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
     {
      title: "Minecraft But Everything I TOUCH Turns FUTURISTIC!!",
      videoUrl: "https://www.youtube.com/watch?v=IARCsUvMrw4",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
     {
      title: "Minecraft, But From PEASANT to KING!",
      videoUrl: "https://www.youtube.com/watch?v=h0XqQaX9ViI",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
     {
      title: "Minecraft, But I Can't Leave This Block...",
      videoUrl: "https://www.youtube.com/watch?v=Y1CGPYsKw6U",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft but i am a Demon",
      videoUrl: "https://www.youtube.com/watch?v=Em1jCQk-4kc",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Cheating with +100 luck lucky block race",
      videoUrl: "https://www.youtube.com/watch?v=6ON-kSPP_o0&t=33s",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft but i have 1 billion xp",
      videoUrl: "https://www.youtube.com/watch?v=FS4nzhGkECg",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But I Can Buy Scary Entities Powers!",
      videoUrl: "https://www.youtube.com/watch?v=9AILyAt0EKU",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft but i have 1 billion death",
      videoUrl: "https://www.youtube.com/watch?v=UqEVaZM1EtE",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft but i survive 1 billion days",
      videoUrl: "https://www.youtube.com/watch?v=Y85JxP5KFl4",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft But , It Gets SCARY!!!",
      videoUrl: "https://www.youtube.com/watch?v=kwk5mfD5YuQ",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "Minecraft, But You Can CUT Any Block! 2",
      videoUrl: "https://www.youtube.com/watch?v=jLsCPlqmO5w",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
    {
      title: "This Prison Took 17 Hours to Escape…",
      videoUrl: "https://www.youtube.com/watch?v=FjC5tPciAmU&t=4s",
      price: "50$",
      version: "Minecraft 1.20.1",
      badge: "Mod"
    },
  ]
};

// Manually curated partner mods - added by hand, no live feed / auto-update.
// Add or remove entries here the same way you edit STORE_DATA.videos above.
export const PARTNER_CURATED_MODS = [
  {
    title: "I Made a SCANNER To Find the EVIL VILLAGER",
    videoUrl: "https://youtu.be/kpSTWG7_SUE",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Minecraft but there are Custom Cookies",
    videoUrl: "https://youtu.be/6hNDiuEf_D8",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "The Lost Santa",
    videoUrl: "https://www.youtube.com/watch?v=85ph1ll8Xo8",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Never Have I Ever",
    videoUrl: "https://www.youtube.com/watch?v=EuVJ4dMv35E",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Would You Rather",
    videoUrl: "https://www.youtube.com/watch?v=Hj-uLGNZAcw",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Craft Gamemodes",
    videoUrl: "https://www.youtube.com/watch?v=GDTVVWHNGb8",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Custom Hungerbars",
    videoUrl: "https://www.youtube.com/watch?v=_4UJAe1RHEs",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Custom Armor",
    videoUrl: "https://www.youtube.com/watch?v=cZxIUbQq-1s",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Freeze Everything",
    videoUrl: "https://www.youtube.com/watch?v=B9N1kN2Niz0",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Paintings Are Portals",
    videoUrl: "https://www.youtube.com/watch?v=TLTX_jyIsaU",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Custom Sprints",
    videoUrl: "https://www.youtube.com/watch?v=_rMvCU7Ycjw",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Doctor Strange Items",
    videoUrl: "https://www.youtube.com/watch?v=yVSB7LTxbUg",
    price: "",
    version: "",
    badge: "Mod"
  },
  {
    title: "Turn World Into TNT",
    videoUrl: "https://www.youtube.com/watch?v=R6XwtgBH-B0",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Die To Win",
    videoUrl: "https://www.youtube.com/watch?v=C-snFqgua44",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Copy Paste Tools",
    videoUrl: "https://www.youtube.com/watch?v=5GudWmtJFDM",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Minecraft Drawn",
    videoUrl: "https://www.youtube.com/watch?v=fjI6k5ds9Qg",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Mix Anything",
    videoUrl: "https://www.youtube.com/watch?v=GBMcP3QAFRs",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Raining Creepers",
    videoUrl: "https://www.youtube.com/watch?v=GRwKwuh9xws",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "One Million Blocks",
    videoUrl: "https://www.youtube.com/watch?v=xOVzN973z2U",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "The World Is Lava",
    videoUrl: "https://www.youtube.com/watch?v=aa83GpBbY-c",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "One Million Diamonds",
    videoUrl: "https://www.youtube.com/watch?v=KwPPQrZVkGM",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Custom XP",
    videoUrl: "https://www.youtube.com/watch?v=kt5UyIdgxFU",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "One Million XP",
    videoUrl: "https://www.youtube.com/watch?v=_OaHf7GHCpU",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "One Million XP 2",
    videoUrl: "https://www.youtube.com/watch?v=S1ywUmY1kqc",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "One Million Hearts",
    videoUrl: "https://www.youtube.com/watch?v=0b1M5ELbTIQ",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Custom Bosses",
    videoUrl: "https://www.youtube.com/watch?v=qLhEW8_C_tc",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Elemental TNT",
    videoUrl: "https://www.youtube.com/watch?v=4S0BPuP690E",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Custom Diamonds",
    videoUrl: "https://www.youtube.com/watch?v=fgMQ8n5F_UM",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Hearts Touch",
    videoUrl: "https://www.youtube.com/watch?v=YleNSHMCUbE",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Come To Life",
    videoUrl: "https://www.youtube.com/watch?v=OdRzffsn9Kc",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Peasant To King",
    videoUrl: "https://www.youtube.com/watch?v=k9i8cw--u2w",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Minecraft Surgery",
    videoUrl: "https://www.youtube.com/watch?v=v7IF1dvGz2Q",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Not Minecraft",
    videoUrl: "https://www.youtube.com/watch?v=sig4ZMGq2pQP",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Nerd To Popular",
    videoUrl: "https://www.youtube.com/watch?v=OwO5fvFlKt8",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Minecraft Restaurant",
    videoUrl: "https://www.youtube.com/watch?v=_l8qYLUs9Jk",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Elemental Block",
    videoUrl: "https://www.youtube.com/watch?v=nLI4ZOfjIEY",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Pirate To Captain",
    videoUrl: "https://www.youtube.com/watch?v=L4otnDMJjaA",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "One Million IQ",
    videoUrl: "https://www.youtube.com/watch?v=L_c59icVCYg",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "One Scary Block",
    videoUrl: "https://www.youtube.com/watch?v=ED9jTZnKRlo",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Minecraft Airport",
    videoUrl: "https://www.youtube.com/watch?v=rI-dJ9MNLfM",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Hated To Loved",
    videoUrl: "https://www.youtube.com/watch?v=8qt00oH8b4M",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Survive The Circle",
    videoUrl: "https://www.youtube.com/watch?v=F8Wi3DAxxL8",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Open A Car Dealership",
    videoUrl: "https://www.youtube.com/watch?v=xnS_LxA4aOM",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "One Million Emeralds",
    videoUrl: "https://www.youtube.com/watch?v=J19jzjdZsDo",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Open A Business",
    videoUrl: "https://www.youtube.com/watch?v=pLoU9ttSZzM",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "One Million Super Ores",
    videoUrl: "https://www.youtube.com/watch?v=jxeKHx5yXJo",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "One Lucky Block",
    videoUrl: "https://www.youtube.com/watch?v=mh1fWgasq3A",
    price: "",
    version: "",
    badge: "Mod"
  },
  {
    title: "Super Items",
    videoUrl: "https://www.youtube.com/watch?v=uoD1M6Kg_yg",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Bedrock Items",
    videoUrl: "https://www.youtube.com/watch?v=2QRutblf-F4",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Random Block Chunks",
    videoUrl: "https://www.youtube.com/watch?v=XQwcVJMl9YM",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Custom Bows",
    videoUrl: "https://www.youtube.com/watch?v=DOFse0Px5oo",
    price: "",
    version: "",
    badge: "Plugin"
  },
  {
    title: "Custom Swords",
    videoUrl: "https://www.youtube.com/watch?v=L0fE-TZmfMw",
    price: "",
    version: "",
    badge: "Plugin"
  },
];